/**
 * Placeholder status line until the Morning Intel feed reports real batch
 * timing from the backend.
 */
export const mockStatusLine =
  'Published 2 Jul, 18:00 UTC · overnight batch complete · next run tonight 18:00 UTC';
